export default __webpack_public_path__ + "static/media/stat3.f01ccd15.png";